import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  submissions: [],
  selectedSubmission: null,
  isLoading: false,
  error: null,
  filter: {
    project_id: "",
    status: "",
  },
};

const submissionSlice = createSlice({
  name: "submission",
  initialState,
  reducers: {
    setSubmissions(state, action) {
      state.submissions = action.payload;
    },
    setSelectedSubmission(state, action) {
      state.selectedSubmission = action.payload;
    },
    removeSubmission(state, action) {
      state.submissions = state.submissions.filter(
        (s) => s.id !== action.payload
      );
    },
    updateSubmissionStatus(state, action) {
      const { id, status } = action.payload;
      const submission = state.submissions.find((s) => s.id === id);
      if (submission) {
        submission.status = status;
      }
      if (state.selectedSubmission && state.selectedSubmission.id === id) {
        state.selectedSubmission.status = status;
      }
    },
    setFilter(state, action) {
      state.filter = { ...state.filter, ...action.payload };
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    resetState(state) {
      state.submissions = [];
      state.selectedSubmission = null;
      state.isLoading = false;
      state.error = null;
      state.filter = { project_id: "", status: "" };
    },
  },
});

export const submissionActions = submissionSlice.actions;
export default submissionSlice.reducer;
